module.exports = __webpack_public_path__ + "static/img/cont40_02.4f14103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_02.jpg
// module id = Newz
// module chunks = 0